"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function search(timestamps, timestamp, mode) {
    let leftPointer = 0;
    let rightPointer = timestamps.length - 1;
    let middle = 0;
    while (leftPointer <= rightPointer) {
        middle = Math.floor((rightPointer + leftPointer) / 2);
        if (timestamp < timestamps[middle]) {
            rightPointer = middle - 1;
        }
        else if (timestamp > timestamps[middle]) {
            leftPointer = middle + 1;
        }
        else {
            // Exact match
            return middle;
        }
    }
    if (mode === "exact") {
        return -1;
    }
    if (timestamps[middle] > timestamp) {
        return mode === "ceil" ? middle : middle - 1;
    }
    else {
        return mode === "ceil" ? middle + 1 : middle;
    }
}
exports.default = search;
//# sourceMappingURL=search.js.map